import {createReducer, on} from '@ngrx/store';
import * as LocationActions from './location.actions';
import {Location} from '../location.model';

export interface LocationState {
  detail?: Location;
  list?: Location[];
  loadingStatus?: string;
}

export const locationFeatureKey = 'location';
export const initialState: LocationState = {};

export const locationReducer = createReducer(
  initialState,
  on(LocationActions.loadLocations, state => ({
    ...state,
    loadingStatus: 'loading',
  })),

  on(LocationActions.loadLocationSuccess, (state, {location}) => ({
    ...state,
    detail: location,
    loadingStatus: 'success',
  })),

  on(LocationActions.loadLocationsSuccess, (state, {locations, status}) => ({
    ...state,
    list: locations,
    loadingStatus: status,
  })),

  on(LocationActions.loadLocationsError, state => ({
    ...state,
    loadingStatus: 'error',
  })),

  on(LocationActions.createLocation, state => ({
    ...state,
    loadingStatus: 'loading',
  })),

  on(LocationActions.createLocationSuccess, (state, {location}) => ({
    ...state,
    list: [...(state.list ?? []), location],
    loadingStatus: 'success',
  })),

  on(LocationActions.createLocationError, state => ({
    ...state,
    loadingStatus: 'error',
  })),

  on(LocationActions.editLocation, state => ({
    ...state,
    loadingStatus: 'loading',
  })),

  on(LocationActions.editLocationSuccess, (state, {location}) => ({
    ...state,
    detail: location,
    loadingStatus: 'success',
  })),

  on(LocationActions.editLocationError, state => ({
    ...state,
    loadingStatus: 'error',
  })),

  on(LocationActions.deleteLocation, state => ({
    ...state,
    loadingStatus: 'loading',
  })),

  on(LocationActions.deleteLocationSuccess, (state, {status}) => ({
    ...state,
    list: state.list?.filter(loc => loc.id !== status),
    loadingStatus: 'success',
  })),

  on(LocationActions.deleteLocationSuccess, (state, {status}) => ({
    ...state,
    list: state.list?.filter(loc => loc.id !== status),
    loadingStatus: 'success',
  })),

  on(LocationActions.deleteLocationError, state => ({
    ...state,
    loadingStatus: 'error',
  })),

  on(LocationActions.resetLoadingStatus, (state) => ({
    ...state,
    loadingStatus: 'idle'
  })),
);
